<template>
  <ElButton
    v-bind="$attrs"
    type="primary"
    native-type="button"
    icon="el-icon-plus"
    :loading="loading"
    @click.native.prevent="createReleaseHandler"
  >
    {{ $t('APP.RELEASES.NEW') }}
  </ElButton>
</template>

<script>
import { mapActions } from 'vuex';
import { CREATE_NEW_RELEASE } from '@/store/types';
import packageName from '@/mixins/packageName';

export default {
  name: 'CreateReleaseButton',
  mixins: [packageName],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      createRelease: CREATE_NEW_RELEASE,
    }),

    createReleaseHandler() {
      this.loading = true;

      return this.createRelease(this.packageName)
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
